// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__fhtNa","text":"SelectPayment_text__3Lx-9","title":"SelectPayment_title__CH3_1","btn":"SelectPayment_btn__12ZU_"};